import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import { Tooltip } from '@mui/material';
import { t } from '@lingui/core/macro';
import { useAppAppearance } from '../contexts/AppearanceContext';
import '../App.css';

export default function AppearanceToggle(): React.ReactElement {
  const { mode, toggleAppearance } = useAppAppearance();
  const isDark = mode === 'dark';
  const label = isDark ? t`Switch to light mode` : t`Switch to dark mode`;

  return (
    <Tooltip title={label}>
      <button type="button" className="appearance-toggle" onClick={toggleAppearance} aria-label={label}>
        {isDark ? <LightModeRoundedIcon aria-hidden="true" /> : <DarkModeRoundedIcon aria-hidden="true" />}
      </button>
    </Tooltip>
  );
}
